export class Index {

    public indexCollectionInit: any;
    public indexCollectionEnd: any;

}
